/* eslint-disable */
export namespace URI {
  export function parse(str: string) {
    var o = parseOptions,
      m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str) || 'strict',
      uri = {},
      i = 14

    while (i--) {
      uri[o.key[i]] = m[i] || ''
    }

    uri[o.q.name] = {}
    /* eslint-disable-next-line no-magic-numbers */
    uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
      if ($1) {
        uri[o.q.name][$1] = $2
      }
    })

    return uri
  }

  const parseOptions = {
    strictMode: false,
    key: [
      'source',
      'protocol',
      'authority',
      'userInfo',
      'user',
      'password',
      'host',
      'port',
      'relative',
      'path',
      'directory',
      'file',
      'query',
      'anchor'
    ],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      /* eslint-disable-next-line */
      strict:
        /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      /* eslint-disable-next-line */
      loose:
        /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  }

  export function getParam(custom_params) {
    var query_string = {},
      query = custom_params
        ? custom_params
        : window.location.search.substring(1),
      vars = query.split('&')

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (typeof query_string[pair[0]] === 'undefined') {
        query_string[pair[0]] = pair[1]
      } else if (typeof query_string[pair[0]] === 'string') {
        var arr = [query_string[pair[0]], pair[1]]
        query_string[pair[0]] = arr
      } else {
        query_string[pair[0]].push(pair[1])
      }
    }
    return query_string
  }

  export function getHost(request: string): string {
    return this.parse(request).host.replace('www.', '')
  }
}
